'use client'
import { ComponentType, FC, ReactElement } from 'react'
import MobileMenuSlideOutFooter from './slideouts/MobileMenuSlideOutFooter'
import { SlideOutComponentPropsMap, SlideOutComponentType, SlideOutFooterType } from './controllers'
import dynamic from 'next/dynamic'
import { ValueOf } from 'ecosystem'

type SlideOutFooterDictionary = Record<SlideOutFooterType, ReactElement>

interface ISlideOutComponentProps {
  componentId: SlideOutComponentType | null
  extraArgs: unknown
}

interface ISlideOutFooterProps {
  footerId?: SlideOutFooterType | null
}

function dynamicTyped<P>(loader: () => Promise<{ default: ComponentType<P> }>) {
  return dynamic(loader) as ComponentType<P>
}

// components are added to this dictionary, and to access them, you will need to use useSlideOut hook to pass the
// componentId to openSlideOut
const slideOutChildComponentsDict: Record<
  SlideOutComponentType,
  ReturnType<typeof dynamicTyped<any>>
> = {
  categories: dynamicTyped(() => import('./slideouts/SlideOutCategories')),
  mobileMenuStandard: dynamicTyped(() => import('./slideouts/SlideOutMobileMenuStandard')),
  mobileMenuMultiColumn: dynamicTyped(() => import('./slideouts/SlideOutMobileMenuMultiColumn')),
  moreCategories: dynamic(() => import('./slideouts/SlideOutMoreCategories')),
  moreFilters: dynamic(() => import('./slideouts/SlideOutMoreFilters')),
  moreFilters1: dynamic(() => import('./slideouts/SlideOutMoreFilters1')),
  moreFiltersSearch: dynamic(() => import('./slideouts/SlideOutMoreFiltersSearch')),
  search: dynamic(() => import('./slideouts/CustomSlideOutSearch'))
}

export const SlideOutComponent: FC<ISlideOutComponentProps> = ({ componentId, extraArgs }) => {
  if (!componentId) return null

  const Component = slideOutChildComponentsDict[componentId] ?? (
    <div>DEV: no component selected</div>
  )

  return <Component {...(extraArgs as ValueOf<SlideOutComponentPropsMap>)} />
}

export const SlideOutFooter: FC<ISlideOutFooterProps> = ({ footerId }) => {
  if (!footerId) return null
  // components are added to this dictionary, and to access them, you will need to use useSlideOut hook to pass the
  // footerId to openSlideOut
  const dictionary: SlideOutFooterDictionary = {
    default: <div />,

    mobileMenu: <MobileMenuSlideOutFooter />
  }

  return (footerId ? dictionary[footerId] : null) ?? dictionary.default
}
